import React, { useState } from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import Pagination from "components/ui/pagination/Pagination";

export default function SpeedOfServicesDataTable({data}) {
    const { t } = useTranslation();

/* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const speedOfServicesData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <Table>
        <Thead>
                <Tr>
                    <Th>{t("pages.reports.reports_tables.branch")}</Th>
                    <Th>{t("pages.reports.reports_tables.average_order_taking_time")}</Th>
                    <Th>{t("pages.reports.reports_tables.average_order_price")}</Th>
                    <Th>{t("pages.reports.reports_tables.average_delay")}</Th>
                    <Th>{t("pages.reports.reports_tables.maximum_delay")}</Th>
                    <Th>{t("pages.reports.reports_tables.order_count")}</Th>
                    <Th>{t("pages.reports.reports_tables.delay_order_count")}</Th>
                    <Th>{t("pages.reports.reports_tables.net_sales")}</Th>
                    <Th>{t("pages.reports.reports_tables.unique_agents_count")}</Th>
                    <Th>{t("pages.reports.reports_tables.average_acceptance_time")}</Th>
                    <Th>{t("pages.reports.reports_tables.average_closing_time")}</Th>
                </Tr>
        </Thead>
        <Tbody>
            {
            speedOfServicesData?.map((item, index) => (
                <Tr key={index}>  
                    <Td>{item?.BranchName}</Td>
                    <Td>{item?.AverageOrderTakingTime}</Td>
                    <Td>{item?.AverageOrderPrice}</Td>
                    <Td> {item?.AverageDelay}  </Td>
                    <Td> {item?.MaximumDelay} </Td>
                    <Td> {item?.OrderCount} </Td>
                    <Td> {item?.DelayedOrderCount} </Td>
                    <Td> {item?.NetSales} </Td>
                    <Td> {item?.UniqueAgentsCount} </Td>
                    <Td> {item?.AverageAcceptanceTime} </Td>
                    <Td> {item?.AverageClosingTime} </Td>
                </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
            currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
  </>
};

